import { render, staticRenderFns } from "./OrderStatus.vue?vue&type=template&id=e31d016c&"
import script from "./OrderStatus.vue?vue&type=script&lang=js&"
export * from "./OrderStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports